import React from "react";
import { useAuth } from "../../../../contexts/AuthContext";
import SettingsSection from "./SettingsSection";

const GeneralSection = ({ label = "general" }) => {
  const { userInfo } = useAuth();

  return (
    <>
      <div className="pt-8">
        {label === "general" && (
          <>
            <h2 className="font-bold text-gray-800 text-xl pb-3">Profile</h2>
            <SettingsSection content={`${userInfo.fname} ${userInfo.lname}`} />
            <SettingsSection
              title="Photo"
              content={<ProfileImage imgURL={userInfo.imageURL} />}
            />
            <SettingsSection title="email" content={userInfo.email} />
          </>
        )}

        {label === "password" && (
          <>
            <h2 className="font-bold text-gray-800 text-xl pb-3">
              Password & Security
            </h2>
            <SettingsSection title="password" content="********" />
          </>
        )}
      </div>
    </>
  );
};

export const ProfileImage = ({ imgURL = "" }) => {
  return (
    <div className="h-8 w-8 rounded-full bg-green-700">
      <img
        src={imgURL}
        alt="Profile"
        className="w-full h-full bg-cover rounded-full"
      />
    </div>
  );
};

export default GeneralSection;
